import { createClient } from '@supabase/supabase-js';
import { getActiveTeamId } from './activeTeam';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Faltan REACT_APP_SUPABASE_URL o REACT_APP_SUPABASE_ANON_KEY en .env.local'
  );
}

// Inyecta el espacio activo (por pestaña) como cabecera `x-team-id` en CADA
// petición — se lee de sessionStorage en cada llamada (no estático), así dos
// pestañas con espacios distintos envían cada una el suyo. La RLS valida la
// cabecera contra la membresía vía current_team_id().
const customFetch: typeof fetch = (input, init = {}) => {
  const team = getActiveTeamId();
  const headers = new Headers(init.headers);
  if (team) headers.set('x-team-id', team);
  return fetch(input, { ...init, headers });
};

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: window.localStorage,
  },
  global: { fetch: customFetch },
});
